import React, { useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import { reportMap } from './reports';
import { AwaitJobModal } from '../components/AwaitJob';
import { submitJob } from '../hooks/useApiJobs';
import { downloadAllResponses } from './downloadResponses';

const CardTeacherReports = ({ exam_name, test_id, reports, students }) => {
    const { jobId, reset, generateTeacherReport } = submitJob();
    const [downloadProgress, setDownloadProgress] = useState(null);

    const handleLink = report => generateTeacherReport({ testId: test_id, reportId: report });

    const handleDownloadAll = () => {
        downloadAllResponses(exam_name, students, setDownloadProgress);
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle className='text-white'>Reports for {exam_name}</CardTitle>
            </CardHeader>
            <CardBody>
                <ul>
                    {reports.map(rptId => (
                        <li key={rptId}>
                            <span className='link' onClick={() => handleLink(rptId)}>
                                {reportMap[rptId]}
                            </span>
                        </li>
                    ))}
                </ul>
                <div className='mt-3 pt-2 border-top'>
                    <button
                        className='btn btn-outline-primary btn-sm btn-block'
                        onClick={handleDownloadAll}
                        disabled={downloadProgress !== null}
                    >
                        {downloadProgress !== null
                            ? `Downloading... ${downloadProgress}%`
                            : 'Download All Responses (ZIP - PDFs)'}
                    </button>
                    {(!students || students.length === 0) && (
                        <div className='text-muted small text-center mt-1'>
                            (No students found for this exam)
                        </div>
                    )}
                </div>
                <AwaitJobModal jobId={jobId} onClose={reset}>
                    Generating report...
                </AwaitJobModal>
            </CardBody>
        </Card>
    );
};

export default CardTeacherReports;
